export type SettingsFieldType = 'multiselect_products' | 'textarea' | 'select'

export interface SettingsFieldOption {
  label: string
  value: string | number
}

export interface SettingsField {
  key: string
  label: string
  type: SettingsFieldType
  required: boolean
  placeholder?: string | null
  helper?: string | null
  options?: SettingsFieldOption[]
}

export interface AgentMeta {
  agent_type: string
  name: string
  description: string
  column_scoped: boolean
  is_custom: boolean
  // True for menu-aware agents that only work on restaurant campaigns. The
  // backend already filters these from /agent-types when ?campaign= is non-
  // restaurant, so the FE typically doesn't need to inspect this; surfaced
  // for downstream UI affordances (e.g. tooltips).
  requires_chain: boolean
  settings_schema: SettingsField[]
}

export const MANUAL_COLUMN_AGENT_TYPE = 'manual'

export const MANUAL_COLUMN_META: AgentMeta = {
  agent_type: MANUAL_COLUMN_AGENT_TYPE,
  name: 'Manual Column',
  description:
    'Create an empty variable column and enter each contact value yourself.',
  column_scoped: false,
  is_custom: false,
  requires_chain: false,
  settings_schema: [],
}
